import React, { useState, useEffect } from 'react';
import { ArrowRight, Shield, Clock, FileText, CheckCircle } from 'lucide-react';
import '../styles/Hero.css';

const Hero = () => {
   const [currentMetric, setCurrentMetric] = useState(0);

 
  const metrics = [
    { value: "99.9%", label: "Uptime, Owned by Us" },
    { value: "24/7", label: "System Ownership" },
    { value: "10+", label: "Years with .NET" }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentMetric((prev) => (prev + 1) % metrics.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  // Load Calendly widget script once if not present
  useEffect(() => {
    if (typeof window === 'undefined') return;

    // If Calendly is already available, nothing to do
    if (window.Calendly) return;

    // Avoid adding script multiple times
    if (!document.querySelector('script[data-calendly-widget]')) {
      const script = document.createElement('script');
      script.src = 'https://assets.calendly.com/assets/external/widget.js';
      script.async = true;
      script.setAttribute('data-calendly-widget', 'true');
      document.body.appendChild(script);
    }
  }, []);

  const handleBookConsult = () => {
    const calendlyUrl = 'https://calendly.com/edsytech-info/30min';

    // Preferred: open Calendly popup if widget loaded
    if (window?.Calendly?.showPopupWidget) {
      try {
        window.Calendly.showPopupWidget(calendlyUrl);
      } catch (e) {
        // fallback to opening new tab
        window.open(calendlyUrl, '_blank', 'noopener');
      }
    } else {
      // If widget not available yet, open calendly in a new tab
      window.open(calendlyUrl, '_blank', 'noopener');
    }
  };

  return (
    <section id="home" className="hero-section-enterprise">
      <div className="hero-background-subtle"></div>
      
      <div className="hero-container-enterprise">
        <div className="hero-content-enterprise">
          {/* Authority Badge */}
          <div className="hero-badge-enterprise animate-fade-in">
            <Shield className="badge-icon" />
            <span>Enterprise SaaS Ownership Partner</span>
          </div>

          {/* Main Headline - Outcome First */}
          <h1 className="hero-headline-enterprise">
            Your Systems. Your Business. Our Ownership.
          </h1>

          {/* Value Proposition */}
          <p className="hero-subheadline-enterprise">
            We don't just host your infrastructure—we run and maintain the business-critical
            systems your company depends on. .NET-first architecture, secure Azure/AWS
            foundations, and board-ready documentation, backed by a 99.9% uptime SLA.
          </p>

          {/* Credibility Strip */}
          <div className="credibility-strip">
            <div className="credibility-item">
              <CheckCircle className="credibility-icon" />
              <span>10+ years Microsoft technologies</span>
            </div>
            <div className="credibility-item">
              <CheckCircle className="credibility-icon" />
              <span>99.9% uptime SLA</span>
            </div>
            <div className="credibility-item">
              <CheckCircle className="credibility-icon" />
              <span>24/7 system ownership</span>
            </div>
            <div className="credibility-item">
              <CheckCircle className="credibility-icon" />
              <span>Security & compliance</span>
            </div>
          </div>

          {/* CTAs */}
          <div className="hero-cta-group">
            <button className="cta-primary-enterprise" onClick={handleBookConsult}>
              <Clock className="cta-icon" />
              Book a 15-min Architecture Consult
              <ArrowRight className="cta-arrow" />
            </button>
            <button className="cta-secondary-enterprise">
              <FileText className="cta-icon" />
              See the Platform Blueprint
            </button>
          </div>
        </div>

        {/* Trust Dashboard Visual */}
        <div className="hero-visual-enterprise">
          <div className="trust-dashboard">
            <div className="dashboard-header">
              <h3 className="dashboard-title">Business Systems Dashboard</h3>
              <span className="status-badge status-operational">Operational</span>
            </div>

            <div className="metric-showcase">
              {metrics.map((metric, index) => (
                <div 
                  key={index}
                  className={`metric-card ${currentMetric === index ? 'metric-active' : ''}`}
                >
                  <div className="metric-value">{metric.value}</div>
                  <div className="metric-label">{metric.label}</div>
                </div>
              ))}
            </div>

            <div className="reliability-features">
              <div className="feature-item">
                <Shield className="feature-icon" />
                <div className="feature-content">
                  <div className="feature-title">Security Baseline</div>
                  <div className="feature-desc">Azure/AWS compliance ready</div>
                </div>
              </div>
              <div className="feature-item">
                <Clock className="feature-icon" />
                <div className="feature-content">
                  <div className="feature-title">Performance Tuning</div>
                  <div className="feature-desc">Continuous optimization</div>
                </div>
              </div>
              <div className="feature-item">
                <FileText className="feature-icon" />
                <div className="feature-content">
                  <div className="feature-title">Board Documentation</div>
                  <div className="feature-desc">Executive-ready reports</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;